<template>
  <div id="zeppelin">
    <iframe :src="zeppelinUrl" frameborder="0" />
  </div>
</template>

<script>
export default {
  name: "zeppelin",
  data() {
    return {
      timer: ""
    };
  },
  computed: {
    zeppelinUrl() {
      return this.$store.state.zeppelinUrl;
    },
    loginForm() {
      return this.$store.state.loginForm;
    }
  },
  mounted() {
    if (!this.zeppelinUrl) {
      this.zLogin();
    }
  },

  methods: {
    zz() {
      this.$http.get(this.zeppelinUrl);
      this.$store.dispatch(
        "setZeppelinTimer",
        setTimeout(this.zz, 5 * 60 * 1000)
      );
    },
    zLogin() {
      this.$http.get("/gavial/v1/systemsetting").then(res => {
        this.$http({
          url: `${res.data.data.zeppelinUrl}/api/login`,
          method: "post",
          data: {
            userName: this.loginForm.userName,
            password: this.loginForm.password
          },
          transformRequest: data => {
            let form = "";
            for (let it in data) {
              form += `${encodeURIComponent(it)}=${encodeURIComponent(
                data[it]
              )}&`;
            }
            return form;
          }
        }).then(() => {
          this.$store.dispatch("setZeppelinUrl", res.data.data.zeppelinUrl);
          this.$store.dispatch(
            "setZeppelinTimer",
            setTimeout(this.zz, 5 * 60 * 1000)
          );
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
#zeppelin iframe {
  height: 100%;
  width: 100%;
}
</style>
